import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';

import { CertificatesTab } from '../CertificatesTab';
import { RegistrationDateUpdateValidate } from '../../../config/Validate';
import { postAllData } from '../../../service/ProductService';
import { UPDATE_REG_DATE } from '../../../config/ApiConstant';
import { formatYearMonthDate } from '../../../appconfig/AppHelper';

export const RegistrationDateUpdate = () => {
    document.title = 'Registration Date Update | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);

    const [regNo, setRegNo] = useState<any>(null);
    const [date, setDate] = useState<any>(new Date());
    const [submitLoader, setSubmitLoader] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({});

    // Clear all
    const clearAll = () => {
        setRegNo(null);
        setDate(new Date());
        setErrors({});
    };

    // On submit
    const onSubmit = async () => {
        try {
            const { errors, isError } = RegistrationDateUpdateValidate(regNo, date);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setSubmitLoader(true);

                let formData: any = new FormData();
                formData.append('RegNo', regNo);
                formData.append('RegDt', formatYearMonthDate(date));

                const response = await postAllData(UPDATE_REG_DATE, formData);
                if (response) {
                    setSubmitLoader(false);
                    clearAll();
                    toast.current?.show({ severity: 'success', summary: 'Message', detail: response?.message });
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setSubmitLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <CertificatesTab mainTabLabel="Registration Date Update" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    Registration No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(regNo) ? regNo : ''} name="regNo" autoComplete="off" placeholder="Enter Reg No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="date">
                                    Date <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Calendar value={date} dateFormat="dd-mm-yy" onChange={(e: any) => setDate(e.value)} showIcon className={errors['date'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['date']}</small>
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" icon="pi pi-times" className="p-button-secondary" onClick={() => clearAll()} />
                                    <Button label="Save" icon="pi pi-check" onClick={() => onSubmit()} loading={submitLoader} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
